import { html } from 'omni-ui';
import { Om2FormFieldBase, renderError, SHARED_FIELD } from './common/base.js';

/**
 * Render enum as radio buttons
 */
export class Om2FormFieldRadio extends Om2FormFieldBase {
  static metadata = {
    config: {
      label: 'Radio Button',
      overrides: {
        type: 'string',
        radio: true,
      },
      fields: {
        id: SHARED_FIELD,
        title: SHARED_FIELD,
        enum: {
          type: 'array',
          id: 'enum',
          title: 'Options',
          minRows: 1,
          content: [
            {
              type: 'column',
              content: [
                { type: 'ref', key: 'id', id: '__array_id', required: true },
              ],
            },
            {
              type: 'column',
              content: [{ type: 'ref', key: 'name', id: '__array_name' }],
            },
          ],
          removeButton: {
            class: 'is-medium no-border-background is-shadowless is-text',
            icon: {
              id: 'omni:interactive:remove',
              class: 'is-size-2',
            },
          },
          addButton: {
            class: 'is-outlined',
            icon: {
              id: 'omni:interactive:add',
              class: 'is-size-2',
            },
          },
          formModal: {
            fields: {
              __array_id: {
                type: 'string',
                title: 'Id',
                tooltip:
                  'The id uniquely identifies the radio button option and should not change.',
              },
              __array_name: {
                type: 'string',
                title: 'Name',
                tooltip:
                  'This is the "pretty" name that is displayed to the user',
              },
            },
            fullWidth: true,
          },
        },
        tooltip: SHARED_FIELD,
        class: SHARED_FIELD,
        default: SHARED_FIELD,
        required: SHARED_FIELD,
        disabled: SHARED_FIELD,
        readonly: {
          title: 'Read Only',
          type: 'boolean',
          tooltip:
            "Rendered as disabled since HTML radio buttons can't be readonly",
        },
        hasObjectValues: SHARED_FIELD,
      },
    },
  };

  render() {
    const { schema } = this;
    if (schema.type !== 'string')
      return renderError(
        `Radio button must be of type string not ${schema.type}`
      );

    return html`
      <fieldset>
        ${schema.enum.map(
          opt =>
            html`
              <label class="radio has-text-weight-normal">
                <input
                  type="radio"
                  name="${this.key}"
                  .value=${opt.id}
                  ?checked=${(this.data?.id ?? this.data ?? schema.default) ===
                  opt.id}
                  ?required=${schema.required}
                  ?disabled=${schema.disabled ||
                  schema.readonly ||
                  this.context?.readonly ||
                  this._isHidden()}
                  @input=${e => {
                    e.stopPropagation();
                    this.dispatchNewEvent('input', {
                      detail: {
                        name: this.key,
                        value: schema.hasObjectValues ? opt : opt.id,
                      },
                    });
                  }}
                />
                ${opt.name}
              </label>
            `
        )}
      </fieldset>
    `;
  }
}

Om2FormFieldRadio.register('radio');
